<template>
    <div class="manual-close-tip">
        <p>
            客户点击后可以主动结束会话，后续按照满意度设置的逻辑下发满意度评价。用户再发送新消息后，会重新开启会话。
        </p>
        <div class="manual-close-tip__item">
            <p>
                移动端：点击“+”号展示“结束会话”入口
            </p>
            <div class="manual-close-tip__placeholder manual-close-tip__placeholder1"></div>
        </div>
        <div class="manual-close-tip__item">
            <p>
                电脑端：输入框底部展示“结束会话”
            </p>
            <div class="manual-close-tip__placeholder manual-close-tip__placeholder2"></div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.manual-close-tip {
    width: 260px;
    p {
        font-size: 13px;
        line-height: 18px;
        color: #1e2330;
    }
    &__item {
        margin-top: 16px;
        p {
            margin-bottom: 10px;
        }
    }
    .manual-close-tip__placeholder {
        width: 260px;
        background-size: 100% 100%;
    }
    .manual-close-tip__placeholder1 {
        height: 110px;
        background-image: url('../../assets/manual-close-tip-1.png');
        // background-size: 260px 110px;
    }
    .manual-close-tip__placeholder2 {
        height: 102px;
        background-image: url('../../assets/manual-close-tip-2.png');
        // background-size: 260px 102px;
    }
}
</style>
